import _ from 'underscore'
import TemplateView from '../../../../TemplateView'
import {connect} from '../../../../redux/utils'
import {bindActionCreators} from 'redux'
import {
    getActiveTabNum,
    isAccountSettingsTabVisible,
    isPTOTabVisible,
    isSDBTabVisible,
    isWASTabVisible
} from '../../common/selectors'
import {setActiveTabAction} from '../../common/actions'
import {UserManagementConstants} from 'constants'
import Tab from '../../../../components/Tab'
import messageResource from "../../../../messageResource"

export class TabsContainer extends TemplateView {
    constructor({
        setActiveTabAction = () => {},
    }) {
        super(null)

        this.props = {
            setActiveTabAction,
        }

        this.state = {
            tabNum: UserManagementConstants.ACCOUNT_SETTINGS_TAB_NUM,
            showAccountSettingsTab: false,
            showPTOTab: false,
            showSDBTab: false,
            showWASTab: false,
        }

        this._tabsMap = {}

        this.onStatePropertyChanged('tabNum', (newTabNum, prevTabNum) => {
            this._tabsMap[newTabNum].setState({active: true})
            if (prevTabNum !== undefined) {
                this._tabsMap[prevTabNum].setState({active: false})
            }
        })

        this.onStatePropertyChanged('showAccountSettingsTab', _.partial(this._toggleTab, UserManagementConstants.ACCOUNT_SETTINGS_TAB_NUM))
        this.onStatePropertyChanged('showPTOTab', _.partial(this._toggleTab, UserManagementConstants.PTO_SETTINGS_TAB_NUM))
        this.onStatePropertyChanged('showSDBTab', _.partial(this._toggleTab, UserManagementConstants.SICK_DAYS_SETTINGS_TAB_NUM))
        this.onStatePropertyChanged('showWASTab', _.partial(this._toggleTab, UserManagementConstants.WORK_ASSIGNMENTS_TAB_NUM))
    }

    templateHtml() {
        return '<div class="userManagement_tabsContainer"></div>'
    }

    afterRender() {
        this._tabsMap[UserManagementConstants.ACCOUNT_SETTINGS_TAB_NUM] = new Tab({
            id: UserManagementConstants.ACCOUNT_SETTINGS_TAB_NUM,
            onClick: this.props.setActiveTabAction,
            text: messageResource.getMessage('userlist.tabs.accounts_permissions'),
        }).init(this.$el)

        this._tabsMap[UserManagementConstants.PTO_SETTINGS_TAB_NUM] = new Tab({
            id: UserManagementConstants.PTO_SETTINGS_TAB_NUM,
            onClick: this.props.setActiveTabAction,
            text: messageResource.getMessage('userlist.tabs.users_pto'),
        }).init(this.$el)

        this._tabsMap[UserManagementConstants.SICK_DAYS_SETTINGS_TAB_NUM] = new Tab({
            id: UserManagementConstants.SICK_DAYS_SETTINGS_TAB_NUM,
            onClick: this.props.setActiveTabAction,
            text: messageResource.getMessage('userlist.tabs.users_sick_days'),
        }).init(this.$el)

        this._tabsMap[UserManagementConstants.WORK_ASSIGNMENTS_TAB_NUM] = new Tab({
            id: UserManagementConstants.WORK_ASSIGNMENTS_TAB_NUM,
            onClick: this.props.setActiveTabAction,
            text: messageResource.getMessage('userlist.tabs.work_assignments'),
            extraClass: 'workAssignmentTabTips',
        }).init(this.$el)
    }

    _toggleTab = (tabNum, show) => {
        this._tabsMap[tabNum].toggle(show)
    }
}

export default connect(
    (state) => ({
        tabNum: getActiveTabNum(state),
        showAccountSettingsTab: isAccountSettingsTabVisible(state),
        showPTOTab: isPTOTabVisible(state),
        showSDBTab: isSDBTabVisible(state),
        showWASTab: isWASTabVisible(state),
    }),
    (dispatch) => ({
        setActiveTabAction: bindActionCreators(setActiveTabAction, dispatch),
    }),
)(TabsContainer)



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/components/tabs/TabsContainer.js